import { useTranslation } from 'react-i18next';
import { gql, useMutation } from '@apollo/client';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { GET_APPRAISAL_INTERVIEW_BY_ID } from './get-appraisal-interview-by-id.hook';
import { GET_APPRAISAL_INTERVIEWS } from './get-appraisal-interviews.hook';

export const CREATE_APPRAISAL_INTERVIEW = gql`
  mutation createAppraisalInterview($payload: CreateAppraisalInterviewInput!) {
    createAppraisalInterview(payload: $payload) {
      _id
    }
  }
`;

export const useCreateAppraisalInterview = ({ onSuccess }: { onSuccess: () => void }) => {
  const { t } = useTranslation('employee');

  const [createInterview, { loading }] = useMutation(CREATE_APPRAISAL_INTERVIEW, {
    refetchQueries: [GET_APPRAISAL_INTERVIEW_BY_ID, GET_APPRAISAL_INTERVIEWS],
    onCompleted: () => {
      showNotification({
        type: NOTIFICATION_TYPE.success,
        message: t('employeeInterview.notifications.createdInterview'),
      });
      onSuccess();
    },
  });

  return {
    createInterview,
    loading,
  };
};
